import React, { FunctionComponent } from 'react'

import iconCashIn from '../../../assets/icons/pagamentos/icon-trazer-dinheiro.svg'
import { Icon } from '../styles'
import { IconsProp } from '../Icons.type'

const IconDepositoBoleto: FunctionComponent<IconsProp> = ({ size }) => (
  <Icon src={iconCashIn} size={size} />
)
export default IconDepositoBoleto
